/**
 * index.scss 의 --spacing-* 토큰이 정의한 간격 스케일.
 * 키는 토큰 이름의 단계값(--spacing-3 → 3)이고, 주석의 px 는 index.scss 에서만 관리한다.
 */
export const SPACINGS = {
    0.5: 'var(--spacing-0-5)', //   2px
    1: 'var(--spacing-1)', //       4px
    1.5: 'var(--spacing-1-5)', //   6px
    2: 'var(--spacing-2)', //       8px
    2.5: 'var(--spacing-2-5)', //  10px
    3: 'var(--spacing-3)', //      12px
    4: 'var(--spacing-4)', //      16px
    5: 'var(--spacing-5)', //      20px
    6: 'var(--spacing-6)', //      24px
    7: 'var(--spacing-7)', //      28px
    8: 'var(--spacing-8)', //      32px
    10: 'var(--spacing-10)', //    40px
    12: 'var(--spacing-12)', //    48px
    14: 'var(--spacing-14)', //    56px
    16: 'var(--spacing-16)', //    64px
    18: 'var(--spacing-18)', //    72px
    20: 'var(--spacing-20)', //    80px
    30: 'var(--spacing-30)', //   120px
} as const;

export type Spacing = keyof typeof SPACINGS;

export function spacingVar(spacing?: Spacing) {
    return spacing ? SPACINGS[spacing] : '0';
}
